<!-- 我的页面 -->
<template>
  <!-- <div class="main-container"> -->
  <div v-if="show" class="blinds-container">
    <div class="cloths-wrapper">
      <div class="cloth">
        <div class="cloth-noise"></div>
      </div>
      <div class="cloth">
        <div class="cloth-noise"></div>
      </div>
    </div>
    <div class="blinds-wrapper">
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
      <div class="blind-row"></div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
export default {
  name: "Blinds",
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {},

  data() {
    // 这里存放数据
    return {
      show: true
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.show = false;
    }, 6000);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {}
};
</script>

<style lang="less" scoped>
/* Image just for Fun */
.main-container {
  // background: url('https://cdn-images.farfetch-contents.com/thom-browne-medium-grey-super-120s-wool-twill-sack-jacket_15614568_29634540_800.jpg') center center fixed;
  // -webkit-background-size: cover;
  // -moz-background-size: cover;
  // -o-background-size: cover;
  // background-size: cover;
}

.blinds-container {
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  margin: auto;
  animation-name: fade-out;
}

/* This is the animation of the noise effect*/
@-webkit-keyframes noiseAnim {
  0% {
    background-position: 10px 200px;
  }
  20% {
    background-position: -50px 0;
  }
  40% {
    background-position: 100px -10px;
  }
  60% {
    background-position: 0 -150px;
  }
  80% {
    background-position: -100px -30px;
  }
  100% {
    background-position: 160px -60px;
  }
}
@-moz-keyframes noiseAnim {
  0% {
    background-position: 10px 200px;
  }
  20% {
    background-position: -50px 0;
  }
  40% {
    background-position: 100px -10px;
  }
  60% {
    background-position: 0 -150px;
  }
  80% {
    background-position: -100px -30px;
  }
  100% {
    background-position: 160px -60px;
  }
}
@-o-keyframes noiseAnim {
  0% {
    background-position: 10px 200px;
  }
  20% {
    background-position: -50px 0;
  }
  40% {
    background-position: 100px -10px;
  }
  60% {
    background-position: 0 -150px;
  }
  80% {
    background-position: -100px -30px;
  }
  100% {
    background-position: 160px -60px;
  }
}
@keyframes noiseAnim {
  0% {
    background-position: 10px 200px;
  }
  20% {
    background-position: -50px 0;
  }
  40% {
    background-position: 100px -10px;
  }
  60% {
    background-position: 0 -150px;
  }
  80% {
    background-position: -100px -30px;
  }
  100% {
    background-position: 160px -60px;
  }
}
/* End of Noise Animation */

/* Styles for the container of the "blinds" */
.blinds-wrapper {
  width: 100%;
  height: 100%;
  font-size: 0;
  overflow: hidden;
  perspective: 2000px;
  opacity: 1;
}
/* Animation Options */
.blind-row,
.blind-row:before,
.cloth,
.blinds-container {
  // animation-fill-mode: forwards;
  // animation-duration: 3s;
  // animation-delay: 0.5s;

  // animation-duration: 6s;
  // transition: ease all 0.5s;
  // animation-iteration-count: infinite;

  animation-fill-mode: forwards;
  animation-duration: 6s;
  animation-delay: 0.5s;
}
/* Horizontal Lines Styling */
.blind-row {
  height: 3.5%;
  background: #f6f6f6;
  width: 100%;
  display: inline-block;
  box-shadow: 0px 3px 7px 0px #242323;
  margin-bottom: 0.2%;
  transform: rotateX(20deg);
  position: relative;
  animation-name: blind-rotation;
  border: 1px solid #fefefe;
  background: -moz-linear-gradient(
    90deg,
    rgba(227, 227, 227, 1) 0%,
    rgba(237, 237, 237, 1) 31%,
    rgba(246, 246, 246, 1) 68%,
    rgba(252, 252, 252, 1) 84%,
    rgba(252, 252, 252, 1) 100%
  ); /* ff3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(252, 252, 252, 1)),
    color-stop(16%, rgba(252, 252, 252, 1)),
    color-stop(32%, rgba(246, 246, 246, 1)),
    color-stop(69%, rgba(237, 237, 237, 1)),
    color-stop(100%, rgba(227, 227, 227, 1))
  ); /* safari4+,chrome */
  /* background: -webkit-linear-gradient(90deg, rgba(227,227,227,1) 0%, rgba(237,237,237,1) 31%, rgba(246,246,246,1) 68%, rgba(252,252,252,1) 84%, rgba(252,252,252,1) 100%); */ /* safari5.1+,chrome10+ */
  background: -o-linear-gradient(
    90deg,
    rgba(227, 227, 227, 1) 0%,
    rgba(237, 237, 237, 1) 31%,
    rgba(246, 246, 246, 1) 68%,
    rgba(252, 252, 252, 1) 84%,
    rgba(252, 252, 252, 1) 100%
  ); /* opera 11.10+ */
  background: -ms-linear-gradient(
    90deg,
    rgba(227, 227, 227, 1) 0%,
    rgba(237, 237, 237, 1) 31%,
    rgba(246, 246, 246, 1) 68%,
    rgba(252, 252, 252, 1) 84%,
    rgba(252, 252, 252, 1) 100%
  ); /* ie10+ */
  /* background: linear-gradient(0deg, rgba(227,227,227,1) 0%, rgba(237,237,237,1) 31%, rgba(246,246,246,1) 68%, rgba(252,252,252,1) 84%, rgba(252,252,252,1) 100%); */ /* w3c */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#FCFCFC', endColorstr='#E3E3E3',GradientType=0 ); /* ie6-9 */
}
/* Animations */
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes blind-rotation {
  from {
    transform: rotateX(20deg);
  }
  to {
    transform: rotateX(-84deg);
  }
}

@keyframes blind-contraction {
  0% {
    height: 10%;
  }
  80% {
    height: 1%;
  }
  100% {
    height: 10%;
  }
}

.blind-row:before {
  content: " ";
  position: absolute;
  top: 0;
  width: 100%;
  background: #e6e6e6;
  height: 10%;
  box-shadow: 0px 1px 5px #d1d1d1;
  animation-name: shadow-animation;
}

/* Vertical Cloth Styling */
.cloths-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
}

.cloth {
  height: 100%;
  width: 1.7%;
  max-width: 18vh;
  /*background:
  linear-gradient(45deg, #dbcccc 12%, transparent 0, transparent 88%, #e9e9e7 0),
  linear-gradient(135deg, transparent 37%, #dbdada 0, #fcfcfc 63%, transparent 0),
  linear-gradient(45deg, transparent 37%, #dddcdc 0, #d5d5cd 63%, transparent 0) #f3f3f3; */
  background-color: #e3e3e3;
  background-image: url("data:image/svg+xml,%3Csvg width='5' height='5' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23e9e9e9' fill-opacity='0.53' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  top: 0;
  bottom: 0;
  box-shadow: 0px 1px 3px #aca8a8;
  animation-name: cloth-animation;
  animation-name: texture-animation;
}
.cloth:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* ff3.6+ */
  /* safari4+,chrome */
  /* safari5.1+,chrome10+ */
  /* opera 11.10+ */
  /* ie10+ */
  /* w3c */
  /* ie6-9 */
  background: -moz-linear-gradient(
    0deg,
    rgba(227, 227, 227, 0.25) 0%,
    rgba(227, 227, 227, 0.2) 26%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(214, 214, 214, 0.17) 78%,
    rgba(166, 166, 166, 0.15) 100%
  ); /* ff3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(0%, rgba(227, 227, 227, 0.25)),
    color-stop(26%, rgba(227, 227, 227, 0.2)),
    color-stop(50%, rgba(255, 255, 255, 0.18)),
    color-stop(78%, rgba(214, 214, 214, 0.17)),
    color-stop(100%, rgba(166, 166, 166, 0.15))
  ); /* safari4+,chrome */
  background: -webkit-linear-gradient(
    0deg,
    rgba(227, 227, 227, 0.25) 0%,
    rgba(227, 227, 227, 0.2) 26%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(214, 214, 214, 0.17) 78%,
    rgba(166, 166, 166, 0.15) 100%
  ); /* safari5.1+,chrome10+ */
  background: -o-linear-gradient(
    0deg,
    rgba(227, 227, 227, 0.25) 0%,
    rgba(227, 227, 227, 0.2) 26%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(214, 214, 214, 0.17) 78%,
    rgba(166, 166, 166, 0.15) 100%
  ); /* opera 11.10+ */
  background: -ms-linear-gradient(
    0deg,
    rgba(227, 227, 227, 0.25) 0%,
    rgba(227, 227, 227, 0.2) 26%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(214, 214, 214, 0.17) 78%,
    rgba(166, 166, 166, 0.15) 100%
  ); /* ie10+ */
  background: linear-gradient(
    90deg,
    rgba(227, 227, 227, 0.25) 0%,
    rgba(227, 227, 227, 0.2) 26%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(214, 214, 214, 0.17) 78%,
    rgba(166, 166, 166, 0.15) 100%
  ); /* w3c */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#E3E3E3', endColorstr='#A6A6A6',GradientType=1 ); /* ie6-9 */
}
.cloth:after {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  content: " ";
  /* IE9, iOS 3.2+ */
  /* Android 2.3 */
  /* IE10+ */
  /* ff3.6+ */
  /* safari4+,chrome */
  /* safari5.1+,chrome10+ */
  /* opera 11.10+ */
  /* ie10+ */
  /* w3c */
  /* ie6-9 */
  background: -moz-linear-gradient(
    0deg,
    rgba(135, 135, 135, 0.15) 0%,
    rgba(207, 207, 207, 0.15) 24%,
    rgba(163, 163, 163, 0.15) 64%,
    rgba(250, 250, 250, 0.15) 85%,
    rgba(218, 214, 219, 0.15) 99%,
    rgba(216, 212, 217, 0.15) 100%
  ); /* ff3.6+ */
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(0%, rgba(135, 135, 135, 0.15)),
    color-stop(24%, rgba(207, 207, 207, 0.15)),
    color-stop(64%, rgba(163, 163, 163, 0.15)),
    color-stop(85%, rgba(250, 250, 250, 0.15)),
    color-stop(99%, rgba(218, 214, 219, 0.15)),
    color-stop(100%, rgba(216, 212, 217, 0.15))
  ); /* safari4+,chrome */
  background: -webkit-linear-gradient(
    0deg,
    rgba(135, 135, 135, 0.15) 0%,
    rgba(207, 207, 207, 0.15) 24%,
    rgba(163, 163, 163, 0.15) 64%,
    rgba(250, 250, 250, 0.15) 85%,
    rgba(218, 214, 219, 0.15) 99%,
    rgba(216, 212, 217, 0.15) 100%
  ); /* safari5.1+,chrome10+ */
  background: -o-linear-gradient(
    0deg,
    rgba(135, 135, 135, 0.15) 0%,
    rgba(207, 207, 207, 0.15) 24%,
    rgba(163, 163, 163, 0.15) 64%,
    rgba(250, 250, 250, 0.15) 85%,
    rgba(218, 214, 219, 0.15) 99%,
    rgba(216, 212, 217, 0.15) 100%
  ); /* opera 11.10+ */
  background: -ms-linear-gradient(
    0deg,
    rgba(135, 135, 135, 0.15) 0%,
    rgba(207, 207, 207, 0.15) 24%,
    rgba(163, 163, 163, 0.15) 64%,
    rgba(250, 250, 250, 0.15) 85%,
    rgba(218, 214, 219, 0.15) 99%,
    rgba(216, 212, 217, 0.15) 100%
  ); /* ie10+ */
  background: linear-gradient(
    90deg,
    rgba(135, 135, 135, 0.15) 0%,
    rgba(207, 207, 207, 0.15) 24%,
    rgba(163, 163, 163, 0.15) 64%,
    rgba(250, 250, 250, 0.15) 85%,
    rgba(218, 214, 219, 0.15) 99%,
    rgba(216, 212, 217, 0.15) 100%
  ); /* w3c */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#878787', endColorstr='#D8D4D9',GradientType=1 ); /* ie6-9 */
}

/* Cloth Animations */
@keyframes cloth-animation {
  from {
    box-shadow: 0px 1px 7px #767676;
  }
  to {
    box-shadow: 0px 16px 14px 2px #767676;
  }
}
@keyframes texture-animation {
  from {
    background-position: top center;
  }
  to {
    background-position: bottom center;
  }
}
@keyframes shadow-animation {
  from {
    height: 14%;
    box-shadow: 0px 1px 9px #d1d1d1;
  }
  to {
    height: 80%;
    box-shadow: 0px 1px 20px #d1d1d1;
  }
}

.cloth:first-child {
  left: 15%;
}

.cloth:last-child {
  right: 15%;
}
.cloth-noise {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  background-image: url(data:image/png;base64,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);
}

// cloths-wrapper
@media screen and (max-width: 768px) {
  // .cloths-wrapper {
  //   display: none;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/Blinds.vue